import { render, staticRenderFns } from "./Taq.vue?vue&type=template&id=471ad2bb&scoped=true&lang=pug&"
import script from "./Taq.vue?vue&type=script&lang=ts&"
export * from "./Taq.vue?vue&type=script&lang=ts&"
import style0 from "./Taq.vue?vue&type=style&index=0&id=471ad2bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ad2bb",
  null
  
)

export default component.exports